import * as actionType from './ActionType';

export const setStep01 = (data) => ({
  type: actionType.SET_VALUE_STEP01,
  payload: data
});

export const setStep01Business = (data) => ({
  type: actionType.SET_VALUE_STEP01_BUSINESS,
  payload: data
});

export const setIpInfo = (ipInfo) => ({
  type: actionType.SET_IPINFO,
  payload: {
    ipInfo
  }
});
